import React, {useContext, useState} from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {deleteCookies, getPathAndQueryParams, getPathBack, objectLang} from "../functions"
import {AuthContext} from "../context/AuthContext"

export const ModalWin = ({data}) => {

    const lang = objectLang().language
    const l = lang.lang
    const auth = useContext(AuthContext)
    const withOK = data.clickOK !== 'reload' || data.code === 541

    if (!data.desc) {
        if (data.code) {
            data.desc = lang.messages[`code_${data.code}`]
        } else {
            data.desc = lang.messages[`code_999`]
        }
    }
    if (!data.btnOKColor) {
        data.btnOKColor = 'danger'
    }
    if (!data.btnCancelColor) {
        data.btnCancelColor = 'secondary'
    }
    const [show, setShow] = useState(true)
    let classCancel = ""
    if (data.btnCancel === "off") {
        classCancel = "d-none"
    }

    const clickHandler = (str) => {
        if (!str) {
            return window.location.replace(getPathAndQueryParams())
        }

        const arrStrBackspace = str.split(' ')
        setShow(false)

        if (str === 'reload') {
            return window.location.replace(getPathAndQueryParams())

        } else if (str === 'deleteCookies') {
            deleteCookies()
            auth.logout()
            return window.location.replace(getPathAndQueryParams())

        } else if (arrStrBackspace[0] === 'replaceToAuth') {
            return window.location.replace(`/${l}/auth-form`)

        } else if (arrStrBackspace[0] === 'replaceToAuthAndDeleteCookies') {
            deleteCookies()
            auth.logout()
            return window.location.replace(`/${l}/auth-form`)

        } else if (str === 'replaceToMain') {
            return window.location.replace(`/${l}/`)

        } else if (str === 'replaceToMainAndDeleteCookies') {
            deleteCookies()
            auth.logout()
            return window.location.replace(`/${l}/`)

        } else if (str === 'replaceToAuthAndDeleteCookies') {
            deleteCookies()
            auth.logout()
            return window.location.replace(`/${l}/auth-form`)

        } else if (str === 'replaceToBack') {
            const pathBack = getPathBack()
            return window.location.replace(pathBack)

        } else if (arrStrBackspace[0] === 'replaceTo') {
            return window.location.replace(arrStrBackspace[1])

        } else {
            return window.location.replace(getPathAndQueryParams())
        }
    }

    return (
        <>
            <Modal show={show}>
                <Modal.Header className={'d-flex justify-content-between'}>
                    <Modal.Title>{data.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{data.desc}</Modal.Body>
                <Modal.Footer>
                    {withOK && <Button
                        variant={data.btnOKColor}
                        onClick={() => {
                            clickHandler(data.clickOK)
                        }}>
                        {data.btnOK}
                    </Button>}
                    <Button
                        variant={data.btnCancelColor}
                        className={classCancel}
                        onClick={() => {
                            clickHandler(data.clickCancel)
                        }}>
                        {data.btnCancel}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}